import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading">
                屁屁影院
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              海量高清影视资源免费在线观看平台。涵盖电影、电视剧、综艺、动漫等多种类型，无需注册即可畅享最新最热门的影视内容。
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold text-background-50 mb-4 font-heading">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { to: "/category/dianying", label: "电影" },
                { to: "/category/dianshiju", label: "电视剧" },
                { to: "/category/zongyi", label: "综艺" },
                { to: "/category/dongman", label: "动漫" },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-background-50 mb-4 font-heading">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <a
                  href="/about#reputation"
                  className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  用户口碑
                </a>
              </li>
              <li>
                <a
                  href="/about#contact"
                  className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  联系我们
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-background-50 mb-4 font-heading">
              联系方式
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line"></i>
                <span>contact@pipicinema.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-phone-line"></i>
                <span>400-888-8888</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-map-pin-line"></i>
                <span>中国北京市朝阳区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between text-sm text-background-50/40">
          <p>
            &copy; {currentYear} 屁屁影院 pipicinema.com - 所有资源均来自互联网，仅供交流学习使用
          </p>
          <div className="flex items-center gap-4 mt-3 sm:mt-0">
            <a href="#" className="hover:text-background-50/60 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="hover:text-background-50/60 transition-colors cursor-pointer" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}